import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { CompaniesFilterModalComponent } from './filter.modal.container';

export const modalRoutes: Routes = [
  {
    path: '',
    component: CompaniesFilterModalComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(modalRoutes)],
  exports: [RouterModule]
})
export class CompaniesFilterRoutingModule {}
